import AllBusinessContactsPage from '@/business/pages/AllBusinessContactsPage';
import ClientForm from '@/business/pages/ClientForm';
import ProviderForm from '@/business/pages/ProviderForm';

const routes = [
  {
    path: '/clients/:id',
    component: ClientForm,
  },
  {
    path: "/providers/:id",
    component: ProviderForm,
  },
];

const contactTypes = ['clients', 'providers'];
contactTypes.forEach((contactType) => {
  routes.push({
    name: contactType,
    path: `/${contactType}`,
    component: AllBusinessContactsPage,
  });
});

export default routes;



// WEBPACK FOOTER //
// ./src/business/routes.js